import React from "react";

const GamePlayIcon = (props) => {
	return (
		<svg
			width="32"
			height="33"
			viewBox="0 0 32 33"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<rect
				x="0.5"
				y="0.980469"
				width="31"
				height="31"
				rx="15.5"
				stroke="#EFF0F6"
			/>
			<path
				d="M22.8397 17.9885C22.7644 18.0658 22.4799 18.3965 22.215 18.6685C20.6615 20.3791 16.6089 23.1791 14.4877 24.0338C14.1656 24.1711 13.3512 24.4618 12.9161 24.4805C12.4991 24.4805 12.1016 24.3845 11.7224 24.1898C11.2496 23.9178 10.8703 23.4898 10.6624 22.9845C10.5287 22.6338 10.3208 21.5845 10.3208 21.5658C10.113 20.4178 9.9987 18.5525 9.9987 16.4911C9.9987 14.5271 10.113 12.7378 10.2832 11.5725C10.3026 11.5538 10.5105 10.2498 10.7378 9.80313C11.1547 8.98713 11.9691 8.48047 12.8407 8.48047L12.9161 8.48047C13.4837 8.50047 14.6774 9.00713 14.6774 9.0258C16.6842 9.8818 20.6433 12.5445 22.2345 14.3138C22.2345 14.3138 22.6826 14.7685 22.8774 15.0525C23.1814 15.4605 23.332 15.9658 23.332 16.4711C23.332 17.0351 23.1619 17.5605 22.8397 17.9885Z"
				fill="#EEF3F7"
			/>
		</svg>
	);
};

export default GamePlayIcon;
